module.exports = __webpack_public_path__ + "img/自行製作廣告-廣告說明.ec8d0ddf.jpg";